import React, { ReactElement } from "react";
import { EmblaOptionsType } from "embla-carousel";
import { DotButton, useDotButton } from "./CarouselDotButton";
import {
  PrevButton,
  NextButton,
  usePrevNextButtons,
} from "./MultiCarouselArrowButtons";
import useEmblaCarousel from "embla-carousel-react";

type PropType = {
  slides: ReactElement[];
  options?: EmblaOptionsType;
};

const SingleCarousel: React.FC<PropType> = (props) => {
  const { slides, options } = props;
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  if (slides.length == 0) {
    return null;
  }

  return (
    <section className="embla col-span-full" title="Featured Activity Carousel">
      <div className="embla__viewport overflow-hidden" ref={emblaRef}>
        <div className="embla__container flex h-[256px] touch-pan-y touch-pinch-zoom small:h-[400px] medium:h-[440px]">
          {slides.map((slide) => slide)}
        </div>
      </div>

      {slides.length > 1 && (
        <div className="embla__controls mt-4 flex w-full justify-center">
          <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
          <div className="embla__dots mx-4 flex flex-wrap items-center gap-2">
            {scrollSnaps.map((_, index) => (
              <DotButton
                key={index}
                onClick={() => onDotButtonClick(index)}
                className={
                  index === selectedIndex
                    ? "bg-teal-700"
                    : "bg-zinc-500 opacity-30"
                }
              />
            ))}
          </div>
          <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
        </div>
      )}
    </section>
  );
};

export default SingleCarousel;
